<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,

  mounted () {
    this.renderChart({
      labels: ['Sin datos'],
      datasets: [
        {
          backgroundColor: [
            '#9B9B9B',
          ],
          data: [100]
        }
      ]
    }, {responsive: true, maintainAspectRatio: true})
  },
  methods: {
    render(labels, colors, data, showLegend) {
      this.renderChart({
        labels: labels,
        datasets: [
          {
            backgroundColor: colors,
            data: data
          }
        ]
      }, 
      {
        responsive: true, 
        maintainAspectRatio: true,
        legend: {
          display: showLegend
        }
      })
    }
  },
}
</script>
